import { DiscountType } from "@/gen/inventory/common_pb";
import { TaxProfile } from "@/gen/medical_master/common_pb";
import currency from "currency.js";
import React from "react";
import DirhamsIcon from "@/components/ui/dirhams-icon";

function convertToCurrencyRounded(amount: number, allowNegativeNumbers: boolean = true): React.ReactNode {
  const metadata = JSON.parse(localStorage.getItem("pharmacyMetadata") || "{}");
  const currencyCode = metadata.currencyCode || "AED";
  const symbol = currencyCode + " ";
  const formatted = currency(amount, {
    symbol: symbol,
    precision: 2,
    increment: currencyCode === "AED" ? 0.25 : 0.01,
    negativePattern: allowNegativeNumbers ? "-!#" : "!#",
  }).format();

  // if (currencyCode === "AED") {
  //   // Remove the "AED " prefix from formatted string
  //   const numberPart = formatted.replace(/^AED\s*/, "");
  //   return (
  //     <span><DirhamsIcon />{numberPart}</span>
  //   )
  // }
  if (currencyCode === "INR") {
    // For INR, we can use the Indian Rupee symbol
    return (
      "₹" + formatted.replace(/^INR\s*/, "")
    );
  }
  return formatted;
}
function getItemCost(item: {
  price: number,
  quantity: number,
  discount: number
  taxProfile?: string,
  discount_type: string
}) {
  const { discount, discount_type, price, quantity, taxProfile } = item;
  if (quantity <= 0) return {
    cost: 0,
    totalTax: 0,
    applicableTaxesRates: []
  }
  let cost = price * quantity;
  cost = cost - getDiscount({
    price: price,
    quantity: quantity,
    discount_amt: discount,
    discount_type: discount_type
  });

  let totalTax = 0;
  let applicableTaxesRates: { name: string; rate: number; amount: number; }[] = [];

  if (taxProfile) {
    const taxProfileData = TaxProfile.fromJsonString(taxProfile);
    const finalApplicableTaxes = taxProfileData.applicableTaxes.map(tax => {
      const countryCode = JSON.parse(localStorage.getItem("pharmacyMetadata") || "{}").countryCode;
      if (countryCode === "AE") {
        if (tax.componentCode.includes("VAT")) {
          return {
            ...tax,
          };
        }
      } else if (countryCode === "IN") {
        if (tax.componentCode.includes("CGST") || tax.componentCode.includes("SGST")) {
          return {
            ...tax,
          };
        }
      } else {
        return {
          ...tax,
        };
      }
    })

    totalTax = finalApplicableTaxes.reduce((acc, tax) => {
      if (tax) {
        const taxAmount = (cost * (tax.ratePercent / 100));
        return acc + taxAmount;
      }
      return acc;
    }, 0);
    cost += totalTax;

    applicableTaxesRates = finalApplicableTaxes
      .map(tax => {
        if (tax) {
          return {
            name: tax.componentCode,
            rate: tax.ratePercent,
            amount: (cost * (tax.ratePercent / 100))
          };
        }
        return undefined;
      })
      .filter((tax): tax is { name: string; rate: number; amount: number } => tax !== undefined);
  }

  return {
    cost: cost,
    totalTax: totalTax,
    applicableTaxesRates: applicableTaxesRates
  }
}
function getDiscount(item: {
  price: number,
  quantity: number,
  discount_amt: number,
  discount_type: string
}) {
  const { discount_amt, discount_type, price, quantity } = item;
  if (discount_amt == 0) {
    return 0
  }
  if (discount_type == DiscountType.PERCENTAGE.toString() || discount_type == DiscountType.ALWAYS_PERCENTAGE.toString()) {
    return (price * quantity) * (discount_amt / 100);
  }
  return discount_amt * quantity;
}


export { convertToCurrencyRounded, getItemCost, getDiscount };